import React from 'react';
import speedometerIcon from '../assets/speedometer.svg';
import walletIcon from '../assets/wallet.svg';
import clockIcon from '../assets/clock.svg';
import { getBrand } from '../utils/getBrand';

const AchievementsSection = () => {
  const { brandName } = getBrand();

  const achievements = [
    {
      icon: speedometerIcon,
      metric: '5x',
      description: 'Land better job offers 5x faster',
    },
    {
      icon: walletIcon,
      metric: '2x',
      description: 'Earn up to 2x more',
    },
    {
      icon: clockIcon,
      metric: '40+',
      description: 'Free up 40+ hours every month',
    },
  ];

  return (
    <div className="sm:py-[80px] py-[50px] sm:px-[80px] px-4 bg-white border-t border-gray-200 border-b border-[rgba(0,0,0,0.06)]">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
          <div className="md:col-span-3">
            <h2 className="text-[28px] leading-[34px] font-semibold font-['Public_Sans'] tracking-[0%]">
              What you can achieve with {brandName}:
            </h2>
          </div>
          <div className="md:col-span-9 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {achievements.map((achievement, index) => (
              <div key={index} className="flex flex-col items-start">
                <div className="flex items-center gap-3 mb-4">
                  <img src={achievement.icon} alt="" className="w-6 h-6" />
                  <div className="text-[28px] leading-[28px] font-semibold font-['Public_Sans'] tracking-[-0.8%] text-black">
                    {achievement.metric}
                  </div>
                </div>
                <div className="text-[16px] leading-[22px] font-normal font-['Inter'] tracking-[-0.4px] text-black">
                  {achievement.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementsSection;
